import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgxsFormPluginModule } from "@ngxs/form-plugin";
import { NgxsModule } from "@ngxs/store";

import { SharedModule } from "./../shared/shared.module";
import { ReplacementCardRequestComponent } from "./components/replacement-card-request/replacement-card-request.component";
import { ReplacementCardState } from "./states/replacement-card.state";

@NgModule({
    declarations: [ReplacementCardRequestComponent],
    exports: [ReplacementCardRequestComponent],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        NgxsModule.forFeature([ReplacementCardState]),
        NgxsFormPluginModule,
    ],
})
export class ReplacementCardRequestModule { }
